import Axios from "axios";
import { prepareHttpHeaders } from "../utils/http";
import env, { clearEnv } from "../utils/env";
import { stores } from "../redux/store";
import Actions from "../redux/action-types";

export function login({ ssoToken, username, password }) {
  const isSSOLogin = !!ssoToken;
  const baseUrl = env("BASE_URL");
  return fetch(
    isSSOLogin
      ? `${baseUrl}/authentication/token_login`
      : `${baseUrl}/screens/authentication/login`,
    {
      method: "POST",
      headers: new Headers(prepareHttpHeaders(null, true)),
      body: isSSOLogin
        ? JSON.stringify({ sso_token: ssoToken })
        : JSON.stringify({
            domain: "member",
            username,
            password
          })
    }
  ).then(res => res.json());
}

export function logout() {
  const { RESET_STORE } = Actions;
  clearEnv();
  stores.forEach(({ store }) => {
    store.dispatch({ type: RESET_STORE });
  });
}

export function loginToDashboard({ username, password }) {
  const data = {
    login: {
      username,
      password
    }
  };

  Axios.post(
    `${window.location.host === "localhost:3400" ? "http" : "https"}://${
      window.location.host
    }/signin`,
    data,
    {
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Content-Type": "application/json"
      }
    }
  ).then(() => {
    window.location.href = "/";
  });
}
